import LangEnum from '../lang/LangEnum';
import { OUR_BRAND_NAME } from '../modules/reports/utils/consts';
import { useTranslation } from '../modules/translation/TranslationContext';
import { BRAZIL_DDI_CODE, getWhatsappLink, whatsapp } from '../utils/constants';
import { phoneUnmask } from '../utils/formatters';

const BRAZIL_PHONE_LENGTHS_WITHOUT_DDI = [10, 11];

const toWhatsappPhone = (phone: string) => {
  const digits = phoneUnmask(phone);

  return BRAZIL_PHONE_LENGTHS_WITHOUT_DDI.includes(digits.length)
    ? `${BRAZIL_DDI_CODE}${digits}`
    : digits;
};

interface UseWhatsappContactParams {
  brandName?: string;
  customerSupportPhone?: string | null;
}

const useWhatsappContact = ({ brandName, customerSupportPhone }: UseWhatsappContactParams) => {
  const { translate } = useTranslation();

  const phone =
    brandName && customerSupportPhone ? toWhatsappPhone(customerSupportPhone) : whatsapp.phone;

  const href = getWhatsappLink({ phone, text: translate(whatsapp.contactMessage) });

  const label = translate(LangEnum.GLOBAL_TALK_TO_BRAND, {
    brand: brandName && customerSupportPhone ? brandName : OUR_BRAND_NAME,
  });

  return { href, label };
};

export default useWhatsappContact;
